import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DATA_HOOKS } from './dataHooks';
import {
  ColorPickerItemDriver,
  colorPickerItemDriverFactory,
} from './ColorPickerItem/ColorPickerItem.driver';

export interface ColorPickerDriver extends BaseUniDriver {
  selectByIndex(index: number): Promise<void>;
  selectByColor(color: string): Promise<void>;
  getItemAt(index: number): ColorPickerItemDriver;
  getSuffix(): UniDriver;
  getIsLoading(): Promise<boolean>;
  getLabelAsterisk(): UniDriver;
}

export const colorPickerDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): ColorPickerDriver => {
  const children = base.$$(`[data-hook="${DATA_HOOKS.colorPickerItem}"]`);
  const childByColor = (color) =>
    base.$(`[style="background-color: ${color};"]`);
  const spinnerDriver = base.$(`[data-hook=${DATA_HOOKS.colorPickerLoader}]`);
  return {
    ...baseUniDriverFactory(base),
    selectByIndex: async (index: number) => {
      const child = children.get(index);

      await child.click();
    },
    selectByColor: async (color: string) => {
      await childByColor(color).click();
    },
    getItemAt: (index: number): ColorPickerItemDriver => {
      const child = children.get(index);
      return colorPickerItemDriverFactory(child, body);
    },
    getSuffix: () => base.$(`[data-hook="${DATA_HOOKS.colorPickerSuffix}"]`),
    getIsLoading: () => spinnerDriver.exists(),
    getLabelAsterisk: () =>
      base.$(`[data-hook="${DATA_HOOKS.colorPickerLabelAsterisk}"]`),
  };
};
